import React from 'react';
import Editor from './editor';

function App() {
  return(
    <div style={{padding:10}}>
      <Editor/>
    </div>
  
  );
  
}

export default App;
